import { render, staticRenderFns } from "./CostManagement.vue?vue&type=template&id=f4609fea&scoped=true"
import script from "./CostManagement.vue?vue&type=script&lang=js"
export * from "./CostManagement.vue?vue&type=script&lang=js"
import style0 from "./CostManagement.vue?vue&type=style&index=0&id=f4609fea&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f4609fea",
  null
  
)

export default component.exports